const Ue = {
  init: function (n) {
    (void 0 === n && void 0 !== Ue.zg) || (Ue.zg = !!n), Ue.t || (Ue.t = !0);
  },
  destroy: function () {
    (Ue.t = !1), (Ue.zg = void 0), (Ue.j = void 0);
  },
  setLogger: function (n) {
    "function" == typeof n
      ? (Ue.init(), (Ue.j = n))
      : Ue.info("Ignoring setLogger call since logger is not a function");
  },
  toggleLogging: function () {
    Ue.init(),
      Ue.zg
        ? (console.log("Disabling Braze logging"), (Ue.zg = !1))
        : (console.log("Enabled Braze logging"), (Ue.zg = !0));
  },
  info: function (n) {
    if (Ue.zg) {
      const o = "Braze: " + n;
      null != Ue.j ? Ue.j(o) : console.log(o);
    }
  },
  warn: function (n) {
    if (Ue.zg) {
      const o = "Braze SDK Warning: " + n + " (v4.10.2)";
      null != Ue.j ? Ue.j(o) : console.warn(o);
    }
  },
  error: function (n) {
    if (Ue.zg) {
      const o = "Braze SDK Error: " + n + " (v4.10.2)";
      null != Ue.j ? Ue.j(o) : console.error(o);
    }
  },
};
export default Ue;
